import { useEffect } from 'react'

import type { eventWithTime } from '@rrweb/types'
import type { recordOptions } from 'rrweb'

import { useRrwebClientContext } from '@core/rrweb/hooks/useRrwebClientContext'

/**
 * Records browser interactions using rrweb.
 */
export const useScreenRecorder = (options: recordOptions<eventWithTime>) => {
  const { rrweb } = useRrwebClientContext()

  useEffect(() => {
    if (rrweb) {
      const stopRecording = rrweb.record(options)
      rrweb.record.takeFullSnapshot()
      return () => {
        if (stopRecording) {
          stopRecording()
        }
      }
    }
  }, [rrweb, options])
}
